// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FinancialScreeningGender } from './financialScreeningGender.js';
import type { FinancialScreeningPatientAddress } from './financialScreeningPatientAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class FinancialScreeningPatientRequest {
    'address': FinancialScreeningPatientAddress | null;
    'birthDate': Moment;
    'firstName': string;
    'gender': FinancialScreeningGender;
    'lastName': string;
    'middleName'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof FinancialScreeningPatientRequest>> = [
        {
            "name":     "address",
            "baseName": "address",
            "type":     "FinancialScreeningPatientAddress"
        },
        {
            "name":     "birthDate",
            "baseName": "birthDate",
            "type":     "Date"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "gender",
            "baseName": "gender",
            "type":     "FinancialScreeningGender"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "middleName",
            "baseName": "middleName",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return FinancialScreeningPatientRequest.attributeTypeMap;
    }
}
